const BookingType = Object.freeze({
  FLIGHT: 'flight',
  STAY: 'stay',
  TRANSPORT: 'transport',
  ATTRACTION: 'attraction',
  RESTAURANT: 'restaurant',
  OTHER: 'other',
} as const);

export type BookingType = (typeof BookingType)[keyof typeof BookingType];
export const allBookingType: [BookingType, ...BookingType[]] = Object.values(BookingType) as [
  BookingType,
  ...BookingType[],
];

export default  BookingType;